/* istanbul ignore file */
import React, { useState } from 'react';
import PresaleRequestForm from 'domain/sales/opportunity/presale/request/form/PresaleRequestForm';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import BeforeSubmitModal from 'domain/sales/opportunity/presale/request/shared/modal/BeforeSubmitModal';
import { useFormContext } from 'framework/form';
import { REQUEST_STATUS } from 'domain/sales/opportunity/presale/request/shared/presaleRequestConstants';

const UpdatePresaleLayout = ({ onCancel }: { onCancel?: () => void }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { data } = useFormContext();
  const requestStatus = data?.requestStatus;

  const onSubmitAction = requestStatus === REQUEST_STATUS.DRAFT ? () => setModalOpen(true) : undefined;

  return (
    <UpdateTimelineItemLayout onCancel={onCancel} onSubmitAction={onSubmitAction}>
      <BeforeSubmitModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <PresaleRequestForm />
    </UpdateTimelineItemLayout>
  );
};

export default UpdatePresaleLayout;
